import {ControlledSwitch} from '@hm/fundamental'
import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {ChartViewMode, CHART_VIEW_MODES} from '../../types'

interface ChartViewToggleProps {
  value: ChartViewMode
  onChange: (value: ChartViewMode) => void
}

export const ChartViewToggle: React.FC<ChartViewToggleProps> = ({value, onChange}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const options = useMemo(
    () =>
      CHART_VIEW_MODES.map((mode) => ({
        label: t(`comparativeAnalysis.chart.viewMode.${mode}`),
        value: mode
      })),
    [t]
  )

  return (
    <ControlledSwitch
      name="chart-view-toggle"
      value={value}
      options={options}
      onChange={(newValue) => onChange(newValue as ChartViewMode)}
      data-cy="chart-view-toggle"
    />
  )
}
